import Tooltip from "@/src/components/Tooltip";
import TooltipButton from "@/src/components/Tooltip/components/TooltipButton";
import TooltipPanel from "@/src/components/Tooltip/components/TooltipPanel";
import { IconSize } from "@/src/components/icons/components/IconContainer";
import { InfoCircle } from "nvs-ds-icons/react/core";
import { Body8 } from "@/src/components/typography/components/Body";
import { Label4 } from "@/src/components/typography/components/Label";
import ProfileLabel from "./ProfileLabel";

export const ACHIEVEMENT_TOOLTIP_COPY =
  "Achievements represent your accomplishments in the .SWOOSH ecosystem. Find out when new achievements become available to earn by following @dotSWOOSH on Instagram and Twitter.";
export const ACHIEVEMENT_TOOLTIP_LABEL =
  "Get more information on user achievements";
export const ACHIEVEMENT_LABEL = "Achievements";

const AchievementTooltip = () => {
  return (
    <Tooltip>
      <ProfileLabel className="flex gap-1 items-center">
        {ACHIEVEMENT_LABEL}
        <TooltipButton
          label={ACHIEVEMENT_TOOLTIP_LABEL}
          icon={<InfoCircle fill="text-gray-950" className="text-white" />}
          size={IconSize.sm}
        />
      </ProfileLabel>
      <TooltipPanel
        header={<Label4>{ACHIEVEMENT_LABEL}</Label4>}
        content={<Body8>{ACHIEVEMENT_TOOLTIP_COPY}</Body8>}
        className={`text-${IconSize.sm}`}
      />
    </Tooltip>
  );
};

export default AchievementTooltip;
